import { useBatchedSimpleDutyRosterPeriodStatuses } from "@/-dataloaders/simple-duty-roster-period-statuses"

export function DutyRosterPeriodStatus({ id }: { id: number }) {
  const { data: dutyRosterPeriodStatus } =
    useBatchedSimpleDutyRosterPeriodStatuses(id)
  return dutyRosterPeriodStatus?.name
}
